import React from "react"

const Intro = ({ data }) => {
  if (!data) return <div></div>
  const { title, intro1, intro2, intro3 } = data?.attributes
  return (
    <div className="max-w-screen-xl w-full mx-auto lg:mt-[79px] mt-14 px-7 2xl:px-0">
      <h3 className="font-syne--17 sm:font-syne--20 lg:font-syne--22 font-bold sm-text-center text-left">
        {title}
      </h3>
      <div className="lg:grid grid-cols-3 font-cardo--20 sm:font-cardo lg:mt-[63px] mt-14 xl:space-x-5">
        <p className="sm:w-3/4 sm:mx-auto lg:w-auto lg:left-0 lg:border-l lg:pl-5 lg:pr-8 xl:pr-20 lg:text-left text-center leading-tight">
          {intro1}
        </p>
        <p className="lg:hidden border-b w-1/2 my-5 mx-auto"></p>
        <p className="sm:w-3/4 lg:w-auto lg:left-0 sm:mx-auto lg:border-l lg:pl-5 lg:pr-8 xl:pr-20 lg:text-left text-center leading-tight">
          {intro2}
        </p>
        <p className="lg:hidden border-b w-1/2 my-5 mx-auto"></p>
        <p className="sm:w-3/4 sm:mx-auto lg:w-auto lg:left-0 lg:right-0 lg:pl-5 lg:border-l lg:pr-8 xl:pr-20 lg:text-left text-center leading-tight">
          {intro3}
        </p>
      </div>
    </div>
  )
}

export default Intro
